module.exports = __webpack_public_path__ + "static/img/sc-qr-ig.1bb017d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/sc-qr-ig.png
// module id = Lq7K
// module chunks = 19